import { FC, memo } from 'react';
import { Loader } from '@morf/ui';
import { LoaderOverlayProps } from './types';

const loaderOverlayStyles: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.2)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 10,
};

const LoaderOverlay: FC<LoaderOverlayProps> = () => (
  <div style={loaderOverlayStyles}>
    <Loader />
  </div>
);

export const MemoizedLoaderOverlay = memo(LoaderOverlay);
